function cleanEnv(value) {
  if (!value || typeof value !== 'string') return '';
  return value.replace(/^["']+|["']+$/g, '').trim();
}

function normalizeBaseURL(value) {
  const cleaned = cleanEnv(value);
  if (!cleaned) return '';
  // Already absolute (http/https) or starts with '/'
  if (/^https?:\/\//.test(cleaned) || cleaned.startsWith('/')) return cleaned;
  // Relative path — prepend '/' so it resolves from the domain root, not the current route
  return `/${cleaned}`;
}

const API_CONFIG = {
  baseURL: normalizeBaseURL(process.env.REACT_APP_API_URL),
  apiKey: cleanEnv(process.env.REACT_APP_API_KEY),
  username: cleanEnv(process.env.REACT_APP_API_USERNAME),
  password: cleanEnv(process.env.REACT_APP_API_PASSWORD),
  recaptchaSiteKey: cleanEnv(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
  recaptchaEnterprise: cleanEnv(process.env.REACT_APP_RECAPTCHA_ENTERPRISE) === 'true',
  timeout: 15000,
};

export default API_CONFIG;
